// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__Z7OTP","chapters_button_wrap":"styles_chapters_button_wrap__BZPLX","nextPrevButtons":"styles_nextPrevButtons__nWR8x"};